var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.51,
    height: 34.51,
    viewBox: "0 0 34.51 34.51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m6.28,12.57c.03-.24.05-.49.09-.72.12-.59.38-1.12.81-1.55.56-.57,1.1-1.17,1.71-1.7.92-.8,1.92-.8,2.81.03.94.88,1.85,1.81,2.73,2.76.65.7.65,1.78.01,2.5-.47.54-.99,1.03-1.5,1.53-.1.1-.12.16-.05.29.51,1.03,1.22,1.9,2,2.72.79.85,1.67,1.61,2.65,2.23.28.18.58.33.89.5.38-.39.74-.77,1.13-1.14.28-.26.57-.54.9-.72.7-.39,1.55-.29,2.12.26.97.93,1.92,1.88,2.84,2.85.68.72.69,1.82.03,2.57-.58.66-1.2,1.28-1.83,1.89-.48.47-1.09.71-1.75.8-.05,0-.09.03-.14.04h-.78s-.09-.03-.13-.04c-.44-.08-.89-.13-1.32-.24-1.53-.4-2.93-1.12-4.26-1.96-3.33-2.11-5.9-4.93-7.69-8.45-.5-.99-.9-2.02-1.11-3.12-.07-.35-.1-.71-.14-1.07,0-.1,0-.19,0-.29Zm1.19.18c.05.34.08.69.15,1.03.31,1.44.92,2.77,1.69,4.02,2.05,3.33,4.78,5.93,8.3,7.66,1.08.53,2.2.97,3.42,1.07.74.06,1.39-.1,1.92-.64.47-.48.94-.95,1.4-1.43.5-.51.5-.94,0-1.45-.37-.37-.74-.74-1.11-1.11-.45-.45-.89-.9-1.35-1.34-.37-.36-.77-.36-1.16-.02-.07.06-.13.12-.19.18-.47.47-.93.94-1.4,1.4-.33.32-.69.4-1.08.21-.4-.2-.8-.41-1.18-.65-1.27-.8-2.36-1.81-3.35-2.94-.68-.78-1.3-1.61-1.74-2.55-.36-.77-.31-1,.31-1.59.46-.45.93-.9,1.37-1.37.34-.36.33-.74.01-1.12-.04-.05-.09-.1-.14-.15-.79-.8-1.59-1.59-2.38-2.38-.09-.09-.19-.17-.31-.24-.35-.19-.71-.11-1.07.24-.45.44-.89.9-1.35,1.34-.53.51-.79,1.11-.78,1.85Z",
    fill: "#4d4d4d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.8,6.79c.37.08.68.13.99.21,2.77.72,4.96,2.26,6.59,4.61.91,1.32,1.49,2.77,1.78,4.34.07.36-.06.63-.35.74-.26.1-.58,0-.71-.24-.08-.15-.12-.33-.15-.5-.76-3.43-2.77-5.84-5.95-7.29-.71-.32-1.46-.51-2.22-.66-.47-.09-.67-.62-.36-.96.11-.12.28-.18.39-.25Z",
    fill: "#4d4d4d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.81,10.61c.26.07.64.13.99.26,2.33.85,3.84,2.47,4.48,4.88.04.14.07.29.1.44.06.33-.13.63-.44.7-.3.07-.61-.1-.7-.41-.11-.34-.16-.7-.29-1.04-.78-1.99-2.22-3.21-4.31-3.65-.41-.09-.62-.42-.51-.78.08-.25.31-.41.69-.41Z",
    fill: "#4d4d4d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.26,
    cy: 17.26,
    r: 16.88,
    fill: "none",
    stroke: "#4d4d4d",
    strokeMiterlimit: 10,
    strokeWidth: 0.75
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.5770ff5bb5d1fac6e57ad1c7ac7456d1.svg";
export { ForwardRef as ReactComponent };